<template>
    <div class="shoplist-page">
        <h1>Выберите ресторан</h1>
        <div class="shoplist-container">
            <div class="shoplist">
                <div class="shop" v-for="shop in shops" :key="shop.id" @click="shopselect(shop)" :class="{'shop-offline': shop.online == false}">
                    <h4 :class="{'shop-offilne-span': shop.online == false, 'shop-online-span': shop.online == true}" >Ресторан {{ shop.online == false ? 'не' : '' }}доступен</h4>
                    <span class="shopname"> {{ shop.name }} </span>
                    <span class="shopaddr"> {{ shop.address }} </span>
                    <pre class="shopdesc"> {{ shop.description }} </pre>
                </div>
            </div>
        </div>    
    </div>
</template>

<script>
export default {
    props:['shops'],
    methods:{
        shopselect(shop){
            if (shop.online == true) this.$emit('shopselect', shop)
        }
    }
}
</script>